const SystemLANG = (
  window.navigator.language || window.navigator.userLanguage
).toLowerCase();
//导航函数
export default SystemLANG;
